import _ from 'lodash';
import { createSelector } from 'reselect';

export const selectFormikStore = (store) => store.formik;

export const selectIsTextAreaFocused = createSelector(
  [selectFormikStore],
  (formik) => _.get(formik, 'isTextAreaFocused', false)
);
